import {type Dispatch, type ReactNode, type SetStateAction, useLayoutEffect} from 'react';

import {useAdaptiveElementSize} from '../../../hooks/useAdaptiveElementSize';
import {VehicleMotMeasurement} from '../types/VehicleMotMeasurement';

interface MeasuredProbeProps {
  children: ReactNode;
  kind: 'aggregate' | 'stacked-gap';
  resetKey: string;
  onHeight: Dispatch<SetStateAction<VehicleMotMeasurement>>;
}

export function MeasuredProbe(props: MeasuredProbeProps) {
  const [ref, width, height] = useAdaptiveElementSize<HTMLDivElement>({resetKey: props.resetKey});

  // Reports before paint so the parent picks its MOT layout from this measurement without first
  // painting a stale one.
  useLayoutEffect(
    function reportVehicleWarehouseProbeHeight() {
      props.onHeight({contentKey: props.resetKey, width, value: height});
    },
    [height, props.onHeight, props.resetKey, width] // eslint-disable-line react/exhaustive-deps -- Muted pre-existing violation
  );

  return (
    <div ref={ref} data-vehicle-warehouse-probe-kind={props.kind}>
      {props.children}
    </div>
  );
}
